import Icon from '../components/Icon.vue'

Icon.register({
  sleigh: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M612.7 350.7c18.5 14.7 28.6 37.2 27.2 61-2.2 39-36.9 68.3-75.9 68.3h-516c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h519.3c13.6 0 24.6-11 24.6-24.6 0-7.5-3.3-14.5-9.2-19.2l-9.3-7.4c-6.9-5.5-8-15.6-2.5-22.5l10-12.5c5.5-6.9 15.6-8 22.5-2.5zM32 224v-128c-17.7 0-32-14.3-32-32s14.3-32 32-32h20.7c65.7 0 125.9 37.2 155.3 96s89.5 96 155.3 96h20.7c35.3 0 64-28.7 64-64v-64h96c17.7 0 32 14.3 32 32s-14.3 32-32 32v96c0 53-43 96-96 96v48h-64v-48h-192v48h-64v-52.5c-55.1-14.3-96-63.9-96-123.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/sleigh.js
// module id = 1901
// module chunks = 0